/**
 * Localized messages for CFS-action errors (formula/event/scenario create,
 * update, delete). The backend doesn't always emit an `error_code` for these
 * flows, so the resolver matches on the raw `error.message` text.
 *
 * Add a new entry by extending `CFS_ACTION_ERROR_MESSAGES_BY_MATCH` — keep the
 * `match` value identical to what the backend returns.
 */

export const CFS_ACTION_ERROR_MESSAGES_BY_MATCH = [
  {
    match: 'Executing this request would create a circular reference',
    fr: 'Référence circulaire : cette action est impossible',
    en: 'Circular reference: this action is not possible',
  },
  {
    match: 'Formula end date cannot be before start date',
    fr: 'La date de fin de la formule ne peut pas être antérieure à la date de début',
    en: 'Formula end date cannot be before start date',
  },
];

const DEFAULT_FALLBACK = {
  fr: 'Cette action est impossible. Veuillez contacter le support.',
  en: 'This action is not possible. Please contact support.',
};

const CFS_ACTION_API_PATHS = new Set([
  'create_cfs',
  'update_cfs',
  'delete_cfs',
]);

function normalizeLocale(locale) {
  return locale === 'en' ? 'en' : 'fr';
}

export function isCfsActionApi(api) {
  return typeof api === 'string' && CFS_ACTION_API_PATHS.has(api);
}

export function resolveCfsActionErrorMessage({api, error, locale} = {}) {
  if (!isCfsActionApi(api)) return null;
  const loc = normalizeLocale(locale);
  const message = error?.message || error?.error_message || error?.msg || '';

  for (const entry of CFS_ACTION_ERROR_MESSAGES_BY_MATCH) {
    if (message === entry.match) return entry[loc];
  }

  return DEFAULT_FALLBACK[loc];
}
